export default "__VITE_ASSET__CXK6VcCz__"